module.exports = __webpack_public_path__ + "img/8.3b9294d6.jpg";